function daysUntilAvailableOn(isoDate) {
  const parts = isoDate.split('-').map(Number);
  if (parts.length !== 3 || parts.some((part) => Number.isNaN(part))) return null;

  const [year, month, day] = parts;
  const target = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return Math.round((target - today) / 86400000);
}

function hoursUntilAvailableAt(unixSeconds) {
  const targetMs = Number(unixSeconds) * 1000;
  if (!Number.isFinite(targetMs)) return null;

  return Math.ceil((targetMs - Date.now()) / 3600000);
}

function labelForDays(badge, days) {
  if (days === 1) return badge.dataset.labelOneDay || 'Available in 1 day';
  return (badge.dataset.labelDays || 'Available in __COUNT__ days').replace('__COUNT__', String(days));
}

function labelForHours(badge, hours) {
  if (hours === 1) return badge.dataset.labelOneHour || 'Available in 1 hour';
  return (badge.dataset.labelHours || 'Available in __COUNT__ hours').replace('__COUNT__', String(hours));
}

function hideAvailableOnBadge(badge) {
  badge.hidden = true;
  badge.classList.add('hidden');

  const price = badge.closest('.price');
  if (price) {
    price.classList.remove('price--available-soon');
  }
}

function showAvailableOnBadge(badge, label) {
  badge.textContent = label;
  badge.hidden = false;
  badge.classList.remove('hidden');

  const price = badge.closest('.price');
  if (price) {
    price.classList.add('price--available-soon');
  }

  const cardBadge = badge.closest('.card__badge');
  if (cardBadge) {
    cardBadge.querySelectorAll('[data-available-on-sold-out]').forEach((soldOut) => {
      soldOut.hidden = true;
      soldOut.classList.add('hidden');
    });
  }
}

function updateAvailableOnBadge(badge) {
  const days = daysUntilAvailableOn(badge.dataset.availableOn);
  if (days === null || days < 0) {
    hideAvailableOnBadge(badge);
    return false;
  }

  if (days === 0) {
    const hours = hoursUntilAvailableAt(badge.dataset.availableAt);
    if (hours === null || hours <= 0) {
      hideAvailableOnBadge(badge);
      return false;
    }

    showAvailableOnBadge(badge, labelForHours(badge, hours));
    return true;
  }

  showAvailableOnBadge(badge, labelForDays(badge, days));
  return false;
}

function initAvailableOnBadges(root = document) {
  const badges = root.querySelectorAll
    ? root.querySelectorAll('[data-available-on]:not([data-available-on-ready])')
    : [];

  let needsHourRefresh = false;

  badges.forEach((badge) => {
    badge.setAttribute('data-available-on-ready', '');
    if (updateAvailableOnBadge(badge)) {
      needsHourRefresh = true;
    }
  });

  if (needsHourRefresh) {
    startAvailableOnHourRefresh();
  }
}

function refreshReadyAvailableOnBadges() {
  const badges = document.querySelectorAll('[data-available-on][data-available-on-ready]');
  let needsHourRefresh = false;

  badges.forEach((badge) => {
    if (updateAvailableOnBadge(badge)) {
      needsHourRefresh = true;
    }
  });

  if (!needsHourRefresh && window.__availableOnHourInterval) {
    clearInterval(window.__availableOnHourInterval);
    window.__availableOnHourInterval = null;
  }
}

function startAvailableOnHourRefresh() {
  if (window.__availableOnHourInterval) return;

  window.__availableOnHourInterval = setInterval(refreshReadyAvailableOnBadges, 60 * 1000);
}

function observeAvailableOnBadges() {
  if (window.__availableOnBadgeObserver) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        if (node.matches?.('[data-available-on]')) {
          initAvailableOnBadges(node.parentElement || document);
        } else if (node.querySelector?.('[data-available-on]')) {
          initAvailableOnBadges(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.__availableOnBadgeObserver = observer;
}

function bootAvailableOnBadges() {
  initAvailableOnBadges();
  observeAvailableOnBadges();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootAvailableOnBadges);
} else {
  bootAvailableOnBadges();
}

document.addEventListener('shopify:section:load', (event) => {
  initAvailableOnBadges(event.target);
});
